import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IPasswordChange } from "src/app/shared/models/IPasswordChange";
import { IAuthToken } from "src/app/shared/services/auth.service";
import { ICredentials } from "../../shared/models/ICredentials";
import { IUser } from "./models/IUser";

// TODO can i put this in env? or would even need to because its just a relative path anyway
const userUrl = "/api/user";
const accountUrl = "/api/account";
const confirmUrl = "api/confirm";

@Injectable({
  providedIn: "root",
})
export class UsersService {
  constructor(private http: HttpClient) { }

  getUsers(): Observable<IUser[]> {
    return this.http.get<IUser[]>(userUrl);
  }
  getUser(userId: number): Observable<IUser> {
    return this.http.get<IUser>(`${userUrl}/${userId}`);
  }
  getUserProfile(userId: number): Observable<IUser> {
    return this.http.get<IUser>(`${userUrl}/profile/${userId}`);
  }
  createUser(user: IUser) {
    return this.http.post(userUrl, { user });
  }
  confirmEmail(email: string, token: string): Observable<IAuthToken> {
    return this.http.post<IAuthToken>(confirmUrl, { email, token });
  }
  resetPassword(credentials: ICredentials) {
    return this.http.post(`${accountUrl}/forgot-password`, credentials);
  }
  updateUser(user: IUser) {
    return this.http.put(`${userUrl}/${user.id}`, user);
  }
  deleteUser(userId: number) {
    return this.http.delete(`${userUrl}/${userId}`);
  }
  setUserPassword(userId: number, passwords: IPasswordChange, authToken: IAuthToken) {
    const options = {
      headers: new HttpHeaders()
        .set("Authorization", `Bearer ${authToken.token}`)
        .set("Content-Type", "Application/json"),
    };
    return this.http.put(`${accountUrl}/${userId}`, passwords, options);
  }
  changeUserPassword(userId: number, passwords: IPasswordChange) {
    return this.http.put(`${accountUrl}/${userId}`, passwords);
  }
  sortByUserName(a: IUser, b: IUser) {
    if (a.name.toLowerCase() < b.name.toLowerCase()) {
      return -1;
    }
    if (a.name.toLowerCase() > b.name.toLowerCase()) {
      return 1;
    }
    return 0;
  }
}
